<template>
  <div>
    <main class="layout-default">
      <SeoTemplatePreset>
        <!-- <NavigationMenu />-->
        <slot />

        <!-- <FooterMain />

      <WidgetScrollTop />
      <ListingProjectBlockFullscreenOverlay />-->
      </SeoTemplatePreset>
    </main>
  </div>
</template>

<script setup>
const route = useRoute()
</script>
